module.exports = __webpack_public_path__ + "img/li.071b1d57.svg";